import { render, staticRenderFns } from "./itemDetailCon.vue?vue&type=template&id=cf17679a"
import script from "./itemDetailCon.vue?vue&type=script&lang=js"
export * from "./itemDetailCon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports